module.exports = __webpack_public_path__ + "static/media/socials.bd0389ec.png";